import React, { useState, useEffect, useMemo, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import MovieCard from '../components/MovieCard';
import './HomePage.css';
import axios from 'axios';
import AuthContext from '../context/AuthContext';
import UserHistoryContext from '../context/UserHistoryContext';
import { CARD_STEP, getCardsPerScroll } from '../utils/carousel';

function HomePage() {
  const { user } = useContext(AuthContext);
  const { watchedIds, loading: historyLoading } = useContext(UserHistoryContext);
  const genres = useMemo(() => ["Horror", "Science Fiction", "Drama", "Music", "Animation","Adventure", "Crime"], []);
  const [moviesByGenre, setMoviesByGenre] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchMoviesByGenre = async () => {
      setIsLoading(true);

      try {
        if (!user || !user.id) {
          throw new Error('User id is not available');
        }

        const fetchPromises = genres.map(async genre => {
          const response = await axios.get('/api/movies/movies_by_genre', {
            params: { genres: genre, limit: 20 },
          });
          const movies = response.data[0].movies.filter(movie => !watchedIds.includes(movie.movieid));
          return { genre, movies };
        });

        const fetchedMoviesByGenre = await Promise.all(fetchPromises);
        setMoviesByGenre(fetchedMoviesByGenre);
      } catch (error) {
        console.error('Error fetching movies by genre', error);
        // Implement error handling UI here
      } finally {
        setIsLoading(false);
      }
    };

    // Wait for the shared user-history context to load once so the
    // watched-movie filter is accurate on the first pass.
    if (!historyLoading && user?.id) {
      fetchMoviesByGenre();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [genres, user, historyLoading]);

  const scroll = (genre, direction) => {
    const element = document.getElementById(`grid-${genre}`);
    if (element) {
      if (direction === 'left') {
        element.scrollLeft = 0;
      } else {
        element.scrollLeft += CARD_STEP * getCardsPerScroll();
      }
    }
  };

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="home-page">
      {isLoading ? (
        <p className="page-loading">Loading...</p>
      ) : (
        moviesByGenre.map((genreData) => (
          <div key={genreData.genre} className="genre-section">
            <h1>{genreData.genre}</h1>
            <div className="movie-grid-wrapper">
              <button className="arrow arrow-left" onClick={() => scroll(genreData.genre, 'left')}>&lt;</button>
              <div className="movie-grid" id={`grid-${genreData.genre}`}>
                {genreData.movies.map((movie, index) => (
                  <MovieCard key={index} movie={movie} />
                ))}
              </div>
              <button className="arrow arrow-right" onClick={() => scroll(genreData.genre, 'right')}>&gt;</button>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
export default HomePage;
